import React, {useCallback, useEffect, useState} from "react";
import useEmblaCarousel from "embla-carousel-react";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import CatalogCard from "@/Components/Site/CatalogCard";
import classNames from "classnames";
import "@/Scss/Site/Product/garnitur.scss";

const Garnitur = (props) => {
    const {product = {}} = props;
    const {productsGarnitur = []} = product;
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [selectedSnap, setSelectedSnap] = useState(0);

    const [carouselRef, emblaApi] = useEmblaCarousel(
        {loop: productsGarnitur.length > 1, align: 'start'}
    );

    const scrollTo = useCallback((index) => {
        emblaApi?.scrollTo(index);
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;

        const onReInit = (api) => {
            setScrollSnaps(api.scrollSnapList());
            setSelectedSnap(api.selectedScrollSnap());
        };

        const onSelect = (api) => {
            setSelectedSnap(api.selectedScrollSnap());
        };

        onReInit(emblaApi);

        emblaApi.on('reInit', onReInit);
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('reInit', onReInit);
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    const {registerView} = useViewItemBatcher();

    if (productsGarnitur.length === 0) return null;

    return (
        <div className={`garnitur`}>
            <p className={`garnitur__title`}>Украшения из гарнитура</p>
            <div className={`garnitur__body embla`}>
                <div ref={carouselRef} className={`embla__viewport`}>
                    <div className={`embla__container`}>
                        {productsGarnitur.map((product, i) => {
                            return <CatalogCard
                                key={product.id}
                                el={product}
                                {...props}
                                index={i + 1}
                                registerView={registerView}
                                className={`embla__slide`}
                            />
                        })}
                    </div>
                </div>
                {scrollSnaps.length > 1 && (
                    <div className={`embla__controls`}>
                        <div className={`embla__dots`}>
                            {scrollSnaps.map((_, index) => (
                                <div
                                    key={`dot-${index}`}
                                    className={classNames('embla__dot', {
                                        'embla__dot--selected': index === selectedSnap,
                                    })}
                                    onClick={() => scrollTo(index)}
                                >
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Garnitur;
